import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const services = [
  {
    title: "Brand Strategy",
    description: "Define your position in the market. We create strategic frameworks that establish your Signal Zone, where you become the obvious choice.",
    link: "/what#branding",
  },
  {
    title: "Visual Identity",
    description: "Design that signals clarity. Logo systems, color architecture, and visual language that makes your position unmistakable.",
    link: "/what#branding",
  },
  {
    title: "Marketing",
    description: "Amplify your signal, not the noise. Strategic marketing that reinforces your position across every touchpoint.",
    link: "/what#marketing",
  },
  {
    title: "Creative Services",
    description: "Craft that cuts through. Design, video, and copy that communicates with precision and creates lasting impressions.",
    link: "/what#creative",
  },
];

const ServicesSection = () => {
  return (
    <section className="section-padding bg-black border-t border-white/10">
      <div className="container-wide">
        {/* Section Header */}
        <div className="max-w-3xl mx-auto mb-6 text-center">
          <Reveal className="mx-auto mb-8">
            <p className="label bg-purple text-white px-3 py-1 inline-block">THE SOLUTION</p>
          </Reveal>
          <Reveal className="mx-auto mb-0 pb-0 !overflow-visible" delay={0.1}>
            <h2 className="display-md text-white">
              Strategic & Creative Services
            </h2>
          </Reveal>
          <Reveal className="mx-auto" delay={0.2}>
            <p className="body-lg text-white/60 font-light">
              Built for Brands That Want Real Impact.
            </p>
          </Reveal>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-2 md:grid-cols-2 gap-px bg-white/10 border border-white/10">
          {services.map((service, i) => (
            <Link
              key={service.title}
              to={service.link}
              className="group bg-[#000000] p-5 md:p-12 lg:p-16 transition-all duration-300 hover:bg-[#c0ff09]"
            >
              <Reveal delay={i * 0.1}>
                <h3 className="text-base md:text-3xl font-bold mb-3 md:mb-6 text-white group-hover:text-black transition-colors duration-300 leading-tight">
                  {service.title}
                </h3>
              </Reveal>
              <Reveal delay={0.1 + (i * 0.1)}>
                <p className="text-white/60 leading-snug md:leading-relaxed mb-6 md:mb-12 text-xs md:text-lg group-hover:text-black/80 transition-colors">
                  {service.description}
                </p>
              </Reveal>
              <Reveal delay={0.2 + (i * 0.1)}>
                <span className="inline-flex items-center gap-2 text-xs md:text-sm font-light text-white/60 group-hover:text-black md:group-hover:gap-6 transition-all duration-300">
                  Learn More
                  <ArrowRight size={16} />
                </span>
              </Reveal>
            </Link>
          ))}
        </div>

        {/* View All Link */}
        <Reveal className="mt-16 mx-auto w-fit" delay={0.4}>
          <Link
            to="/what"
            className="inline-flex items-center gap-2 font-light text-white hover:gap-4 transition-all duration-300 border-b border-white pb-1"
          >
            View All Services
          </Link>
        </Reveal>
      </div>
    </section>
  );
};

export default ServicesSection;
